// 地图注册表：新增城市 = 1) 下载 adcode_full.json 放入 src/until/map/  2) 在此加一条配置
// adcode 查询: https://datav.aliyun.com/portal/school/atlas/area_selector
export const mapRegistry = {
    china: {
        label: "全国",
        parent: null,
        json: () => import("@/until/china.json"),
    },
    taian: {
        label: "泰安",
        parent: "china",
        json: () => import("@/until/map/taian.json"),
    },
    // 以后扩展示例:
    // jinan: {
    //   label: "济南",
    //   parent: "china",
    //   bbox: [116.35, 36.02, 117.77, 37.54],
    //   json: () => import("@/until/map/jinan.json"),
    // },
};